export default {"src":"/_next/static/media/raft.db11604c.svg","height":251,"width":212,"blurWidth":0,"blurHeight":0};